import { render } from "./DefaultSvgHouseOut.vue?vue&type=template&id=57922027&scoped=true"
import script from "./DefaultSvgHouseOut.vue?vue&type=script&lang=js"
export * from "./DefaultSvgHouseOut.vue?vue&type=script&lang=js"

import "./DefaultSvgHouseOut.vue?vue&type=style&index=0&id=57922027&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57922027"]])

export default __exports__